import {
  QUERY_KEY_MY_MONITORING_GET_SITE,
  QUERY_KEY_MY_MONITORING_GET_SITE_DETAILS,
  QUERY_KEY_MY_MONITORING_GET_SITE_LIST
} from '@apps-common/apis/my-monitoring/site'
import { QUERY_GET_SITE_DETAILS } from '@apps-common/apis/portal/site-details'
import { queryClient } from '@apps-common/lib'

export const invalidateSiteDetailsQueries = (unitId?: string) => {
  // my monitoring
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_DETAILS(unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_SITE(unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_LIST() })

  // portal
  queryClient.invalidateQueries({ queryKey: QUERY_GET_SITE_DETAILS(unitId) })
}
